/** True after OAuth tokens were written from the URL and side effects are still owed. */
let pendingOAuthLoginSideEffects = false;

export function markPendingOAuthLoginSideEffects() {
  pendingOAuthLoginSideEffects = true;
}

export function clearPendingOAuthLoginSideEffects() {
  pendingOAuthLoginSideEffects = false;
}

/**
 * Returns true once after a successful URL token persist, then clears.
 * Prevents duplicate cart sync / setAuthorized across remounts and callers.
 */
export function claimPendingOAuthLoginSideEffects(): boolean {
  if (!pendingOAuthLoginSideEffects) {
    return false;
  }
  pendingOAuthLoginSideEffects = false;
  return true;
}
